import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Component({
  selector: 'tracker-query-edit-dates',
  template: require('./tracker.query.edit.dates.component.html')
})
export class TrackerQueryEditDatesComponent implements OnInit {
  extraDateFilter: any = null;
  @Input() openDate: any;
  @Input() closeDate: any;
  @Input() modDate: any;
  @Input() currentFilters: any;
  @Input() loading: boolean;

  datePickerOptions = {
    dateFormat: "MMM D YYYY",
    allowFreeText: true
  };

  // Object to store formatted dates for each filter
  dateFormatting: {[key: string]: {formatted: string}} = {};

  constructor(private http: HttpClient) { }

  ngOnInit() {
    // Sets IDs for the date filter objects
    if (!this.openDate.id) {
      this.openDate.id = 'openDate';
    }
    if (!this.closeDate.id) {
      this.closeDate.id = 'closeDate';
    }
    if (!this.modDate.id) {
      this.modDate.id = 'modDate';
    }
    
    // Initialize date formatting objects for each filter
    this.dateFormatting[`start_${this.openDate.id}`] = { formatted: '' };
    this.dateFormatting[`end_${this.openDate.id}`] = { formatted: '' };
    this.dateFormatting[`start_${this.closeDate.id}`] = { formatted: '' };
    this.dateFormatting[`end_${this.closeDate.id}`] = { formatted: '' };
    this.dateFormatting[`start_${this.modDate.id}`] = { formatted: '' };
    this.dateFormatting[`end_${this.modDate.id}`] = { formatted: '' };
  }

  /**
   * Handle date filter updates for both start and end dates
   * @param event The date event
   * @param dateObj The date object to update
   * @param isStartDate Boolean indicating if this is a start date (true) or end date (false)
   */
  onDateFilterUpdate(event: any, dateObj: any, isStartDate: boolean) {
    if (isStartDate) {
      dateObj.startDate = event;
    } else {
      dateObj.endDate = event;
    }
    
    if (!dateObj.id) {
      dateObj.id = 'filter_' + Math.random().toString(36).substr(2, 9);
    }
    
    const prefix = isStartDate ? 'start_' : 'end_';
    const key = `${prefix}${dateObj.id}`;
    
    if (!this.dateFormatting[key]) {
      this.dateFormatting[key] = { formatted: '' };
    }
    
    this.formatAndStoreDate(event, key);
  }

  /**
   * Format a date and store it in the dateFormatting object
   * @param date Any date format
   * @param key The key to store the formatted date under
   */
  private formatAndStoreDate(date: any, key: string): void {
    if (!date) {
      this.dateFormatting[key].formatted = '';
      return;
    }
    
    if (typeof date === 'string') {
      this.convertAndValidateDate(date).then(formattedDate => {
        this.dateFormatting[key].formatted = formattedDate;
      });
      // Set temporary value while converting
      this.dateFormatting[key].formatted = 'Converting...';
    }
  }

  /**
   * Calls a backend command to convert and validate the date string
   * @param dateStr Date string to convert
   * @returns Promise with the converted date
   */
  private convertAndValidateDate(dateStr: string): Promise<string> {
    return this.http.get('/site/convertdate', {
      params: {
        cmd: 'convertdate',
        date: dateStr
      }
    }).toPromise()
      .then((response: any) => {
        if (response && response.success) {
          return `${response.converted} (${response.relative})`;
        } else {
          return response && response.message ? response.message : 'Invalid date';
        }
      })
      .catch(error => {
        console.error('Error converting date:', error);
        return 'Error converting date';
      });
  }
}
